import React, { Component, Fragment } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Container, Typo, HR, ReviewStar } from 'tmt-ui-kit';
// import ReactCSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
// import Scroll from 'react-scroll';

// const ScrollLink = Scroll.Link;
// const Element = Scroll.Element;

import { actions as lxActions } from '~/redux/reducers/lx';
import { actions as tripActions } from '~/redux/reducers/trip';
import { actions as sessionActions } from '~/redux/reducers/session';

import HeadTag from '~/components/Head/HeadTag';
import NotFound from '~/components/NotFound/NotFound';
// import VerifyStatus from '~/components/LocalExpertProfile/VerifyStatus';
// import LocalExpertTrips from '~/components/LocalExpertProfile/LocalExpertTrips';

// import Reviews from '~/components/Reviews';
// import ReviewStar from '~/components/Reviews/ReviewStar';


// const GalleryReview = dynamic(import('../../components/General/Gallery/GalleryReview'), { ssr: false, loading: () => null });

// import { Review } from 'tmt-ui-kit';

// const { Reviews } = Review;

// const Link = dynamic(import('../../components/Link/Link'));

import { getRatingPoint, getResponse } from '~/utils/helpers';
import { path, defaultAvatarImage } from '~/utils/media';
import { getMYFormat } from '~/utils/calendar';
// import Colors from '~/utils/colors';
import config from '~/config';
import moment from 'moment-timezone';

moment.tz.setDefault('Asia/Bangkok');

const VerificationCheck = dynamic(() => import(/* webpackChunkName: "VerificationCheck.components" */'./VerificationCheck'), { ssr: false, loading: () => null });

const Gallery = dynamic(() => import(/* webpackChunkName: "General.Gallery.components" */'../../components/General/Gallery/Gallery'), { ssr: false, loading: () => null });

const Reviews = dynamic(
  () => import(/* webpackChunkName: "Reviews.ReviewsV1.components" */'../../components/Reviews/index.old'),
  { loading: () => null }
);

// const NotFound = dynamic(() => import(/* webpackChunkName: "NotFound.components" */'../../components/NotFound/NotFound'));

const LocalExpertTrips = dynamic(() => import(/* webpackChunkName: "LocalExpertTrips.components" */'../../components/LocalExpertProfile/LocalExpertTrips'));

const LxContainer = styled(Container.InnerContainer)`
  display: flex;
  margin: 32px auto;
  box-sizing: border-box;
  @media only screen and (max-width: 1200px) {
    flex-direction: column;
  }
`;

// const ProfileOuterContainer = styled.div`
//   display: flex;
//   width: 280px;
//   padding-right: 16px;
// `;

const ContentContainer = styled.div`
  /* margin-left: 40px; */
  width: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-left: 32px;
  border-left: 1px solid ${props => props.theme.blueGray};
  @media only screen and (max-width: 1200px) {
    padding-left: 0;
    border: none;
  }
`;

const ProfileContainer = styled.div`
  ${props => (props.isSticky && 'position: relative;')}
  /* width: 420px; */
  display: flex;
  align-items: flex-start;
  ${props => (!props.isSticky && `
    align-items: flex-end;
  `)}
  @media only screen and (max-width: 1200px) {
    border-right: none; 
    padding-right: 0;    
    margin-right: 0px;
    margin-bottom: 16px;
    width: 100%;
  }
  @media only screen and (max-width: 600px) {
    justify-content: center;
  }
  display: flex;
  width: 280px;
  padding-right: 16px;
`;

const FixedContainer = styled.div`
  ${props => (props.isSticky && `
    position: fixed;
    width: 280px;
  `)}
  @media only screen and (max-width: 1200px) {
    ${props => (props.isSticky && 'position: relative;')}
    width: 100%;
  }
  @media only screen and (max-width: 1200px) {
    display: flex;
  }
  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: center;
  }
`;

const ProfilePictureContainer = styled.div`
  width: 280px;
  display: flex;
  justify-content: center;
  ${props => (props.fixScreenWidth === 1366 && props.fixScreenHeight === 768 ? 'margin: 0px 0px 16px;' : 'margin: 0px auto 24px;')}

  @media only screen and (max-width: 1200px) {
    display: block;
    width: fit-content;
    margin: 0px;
    margin-right: 27px;
  }

  @media only screen and (max-width: 600px) {
    margin-right: 0px;
  }
`;

const ProfilePicture = styled.img`
  ${props => (
    props.fixScreenWidth === 1366 && props.fixScreenHeight === 768 ? `
      width: 100px;
      height: 100px;
    ` : `
      width: 160px;
      height: 160px;
    `
  )}
  border-radius: 100%;

@media only screen and (max-width: 1200px) {
  ${props => (
    props.fixScreenWidth === 1366 && props.fixScreenHeight === 768 ? `
      width: 100px;
      height: 100px;
    ` : `
      width: 120px;
      height: 120px;
    `
  )}
}
`;

const ProfileContent = styled.div`
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 1200px) {
    justify-content: center;
  }

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: center;  
  }
`;

const ProfileInfo = styled.div`
  margin-bottom: 16px;

  @media only screen and (max-width: 1200px) {
    margin-right: 48px;
  }

  @media only screen and (max-width: 600px) {
    text-align: center;
    margin-right: 0px;
    margin-top: 16px;
    margin-bottom: 8px;
  }
`;

const TextName = styled(Typo.HeaderTwo)`
  margin: 0px;
  margin-bottom: 4px !important;
`;

const TextCountry = styled(Typo.Paragraph)`
  margin: 0px;
`;

const AboutMe = styled(Typo.HeaderTwo)`
  margin: 0 !important;
`;

const RatingContainer = styled.div`
  display: flex;
  ${props => props.allRating && `
    margin-top: 8px;
    &:first-child {
      margin-top: 0px;
    }
    &:last-child {
      margin-top: 0px;
    }
  `}
  div{
    ${props => props.allRating && `
      display: flex;
      align-items: center;
    `}
  }
`;

const TitleRating = styled(Typo.Paragraph)`
  margin: 0px 0px ${props => props.bestOfLx && '3px'};
`;

const LxIcon = styled.img`
  height: ${props => (props.recommend ? '26px' : '30px')};
  margin-right: ${props => (props.recommend ? '18px' : '20px')};
  ${props => props.recommend && 'margin-left: 3px;'}
`;

const StarContainer = styled.div`
  display: flex;
  ${props => props.allRating && 'margin-left: 42px;'}
`;

const TextStar = styled(Typo.HeaderThree)`
  margin: 0;
`;

const FlexTextContainer = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

const Title = styled(Typo.HeaderFour)`
  width: 145px;
  margin: 0;

  @media only screen and (max-width: 1200px) {
    width: 50%;
    margin: 0;
  }
`;

const Subtitle = styled(Typo.Paragraph)`
  line-height: 0 !important;
`;

const DesktopContainer = styled.div`
  @media only screen and (max-width: 1200px) {
    display: none;
  }
`;

const MoblieContainer = styled.div`
  box-sizing: border-box;
  display: none;

  @media only screen and (max-width: 1200px) {
    display: flex;
  }

  @media only screen and (max-width: 600px) {
    display: block;
  }
`;

const MoblieFirst = styled.div`
  width: 100%;
`;


const IsShowHR = styled.div`
  display: none;
  @media only screen and (max-width: 1200px) {
    display: ${props => (props.isMobile ? 'none' : 'block')};
  }
  @media only screen and (max-width: 1200px) {
    display: block;
  }
`;

const BorderVerified = styled.div`
  width: 100%;
  padding-left: 24px;
  border-left: 1px solid ${props => props.theme.blueGray};
  margin-left: 16px;

  @media only screen and (max-width: 600px) {
    margin-left: 0px;
    padding-left: 0px;
    border: none;
  }
`;

const enhance = connect(
  (state, ownProps) => ({
    home: state.home,
    isError: state.lx.isError,
    lxprofile: (state.lx.data && state.lx.data[ownProps.url.query.slug]) || {},
    locale: 'en',
    loading: state.lx.loading,
    user: state.session.user,
    isMobile: state.app.isMobile,
    sessionData: state.session.data,
    rates: state.info.exchangeRates,
    isWishlisted: state.wishlist.wishlistObj.isWishlisted,
    galleryName: state.gallery.galleryName,
  }), {
    ...lxActions,
    logImpressOldTrip: tripActions.logImpressOldTrip,
    logClickOldTrip: tripActions.logClickOldTrip,
    logClickBookNow: tripActions.logClickBookNow,
    replyReview: tripActions.replyReview,
    addToConversionSource: sessionActions.addToConversionSource
  }
);

const ReviewContainers = styled(Container.InnerContainer)`
  margin: 32px 0 0 0;
  padding: 0;
`;

class LocalExpertProfile extends Component {
  static propTypes = {
    // loading: PropTypes.bool,
    isError: PropTypes.bool,
    locale: PropTypes.string,
    url: PropTypes.object,
    lxprofile: PropTypes.object,
    user: PropTypes.object,
    sessionData: PropTypes.object,
    replyReview: PropTypes.func,
  };

  static async getInitialProps({ store, query, req, res }) {
    const { slug } = query;
    try {
      const data = await store.dispatch(lxActions.getLxData(slug));
      if (data.data.is_redirect) {
        if (res && res.writeHead && data.data.slug) {
          let qstr = '';
          if (req && req.url && req.url.match(/\?.+/)) {
            qstr = req.url.match(/\?.+/);
          }
          res.writeHead(301, {Location: `/local-expert/${data.data.slug}${qstr}`});
          res.end();
        }
      }
    } catch (error) {
      if (res) res.statusCode = 404;
    }
    return {};
  }

  state = {
    // reviewShowCount: 3,
    // selectedCountry: 'all',
    isSticky: true,
    sizeScreen: {
      width: 0,
      height: 0
    }
  }

  componentDidMount() {
    if (!this.props.isError) {
      this.updateWindowDimensions();
      this.handleScroll();
      window.addEventListener('scroll', this.handleScroll, { passive: true });
    }
  }

  componentWillUnmount() {
    if (!this.props.isError) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }

  onReply = (id, text) => {
    this.props.replyReview(id, text);
  }

  updateWindowDimensions = () => {
    this.setState({ sizeScreen: {
      width: window.screen.width,
      height: window.screen.height
    }});
  }

  // checkFaq = () => {
  //   const { lxprofile } = this.props;
  //   let check = false;
  //   if (lxprofile.faq) {
  //     lxprofile.faqs.map((f) => {
  //       if (f.question && f.answer) {
  //         check = true;
  //       }
  //       return null;
  //     });
  //   }
  //   return check;
  // }

  isVerified = () => {
    const {lxprofile} = this.props;
    let count = 0;
    if (lxprofile && lxprofile.verification) {
      if (lxprofile.verification.mobile_verified) {
        count += 1;
      }
      if (lxprofile.verification.id_card_verified && lxprofile.verification.id_card_selfie_verified) {
        count += 1;
      }
      if (lxprofile.verification.email_verified) {
        count += 1;
      }
      if (lxprofile.verification.facebook_verified) {
        count += 1;
      }
      if (lxprofile.verification.guide_license_verified) {
        count += 1;
      }
    }
    if (count >= 2) {
      return true;
    }
    return false;
  }

  // loadMoreReview = () => {
  //   this.setState((state) => {
  //     let newCount = state.reviewShowCount + 3;
  //     if (newCount > this.props.lxprofile.reviews.length) {
  //       newCount = this.props.lxprofile.reviews.length;
  //     }
  //     return { reviewShowCount: newCount };
  //   });
  // }

  // handleSelectedReviewFilter = (country) => {
  //   this.setState({
  //     selectedCountry: country,
  //     reviewShowCount: 3
  //   });
  // }

  handleScroll = () => {
    this.desktopScroll();
    // this.mobileScroll();
  }

  desktopScroll = () => {
    const { top } = this.stickyContainer.getBoundingClientRect();
    const contHeight = this.stickyContainer.offsetHeight;
    const elmHeight = this.stickyElement.offsetHeight;
    if (Math.abs(top) + elmHeight + 100 >= contHeight) {
      this.setState({ isSticky: false });
    } else {
      this.setState({ isSticky: true });
    }
  }

  render() {
    const { sizeScreen, isSticky } = this.state;
    const { lxprofile, isError, locale, url, sessionData, user, galleryName } = this.props;
    if (isError) return <NotFound />;
    const score = lxprofile.rating.average_rating ? getRatingPoint(lxprofile.rating.average_rating) : 0;
    const userCountry = (sessionData.userType && sessionData.userType.type) || null;
    const coverImage = (lxprofile.trips && lxprofile.trips.length > 0 && lxprofile.trips[0].cover_image) || null;
    let lxName = `${lxprofile.name.first} ${lxprofile.name.last}`;
    if (lxprofile.is_travel_agency && lxprofile.company_name) {
      lxName = lxprofile.company_name;
    }
    lxprofile.review_count = (lxprofile.reviews || []).length + lxprofile.travelers_without_review;
    return (
      <Fragment>
        <HeadTag
          title={lxprofile.name && `${lxprofile.name.first} ${lxprofile.name.last} | TakeMeTour`}
          description={lxprofile.profile && lxprofile.profile.about_me}
          image={coverImage ? path(lxprofile.trips[0].cover_image, 'profileCover') : `${config.assetPath}/static/images/lx-cover.jpg`}
        />
        {/* <Helmet
          title={lxprofile.name && `${lxprofile.name.first} ${lxprofile.name.last} | `}
          meta={[{
            description: lxprofile.profile && lxprofile.profile.about_me,
            'og:description': lxprofile.profile && lxprofile.profile.about_me,
            'og:image': (coverImage && path(lxprofile.trips[0].cover_image, 'profileCover', true)) || `${config.assetPath}/static/images/lx-cover.jpg`
          }]}
        /> */}
        <LxContainer>
          <ProfileContainer isSticky={isSticky} ref={c => { this.stickyContainer = c; }}>
            <FixedContainer isSticky={isSticky} ref={c => { this.stickyElement = c; }}>
              <ProfilePictureContainer
                fixScreenWidth={sizeScreen.width}
                fixScreenHeight={sizeScreen.height}
              >
                <ProfilePicture
                  fixScreenWidth={sizeScreen.width}
                  fixScreenHeight={sizeScreen.height}
                  src={lxprofile.avatar_image ? path(lxprofile.avatar_image, 'lxAvatar') : defaultAvatarImage(lxprofile.name.first)}
                  srcSet={`${lxprofile.avatar_image ? path(lxprofile.avatar_image, 'lxAvatar2x') : defaultAvatarImage(lxprofile.name.first, true)} 2x`}
                  alt={lxprofile.name && `${lxprofile.name.first} ${lxprofile.name.last}`}
                />
              </ProfilePictureContainer>
              <ProfileContent>
                <ProfileInfo>
                  {lxprofile.name && (
                    <TextName>
                      {lxName}
                    </TextName>
                  )}
                  <TextCountry>{lxprofile.profile && lxprofile.profile.current_city && `${lxprofile.profile.current_city}, `}{lxprofile.last_country || 'Thailand'}</TextCountry>
                </ProfileInfo>
                {lxprofile.rating && lxprofile.rating.score > 0 && lxprofile.rating.count && lxprofile.verification && !lxprofile.verification.has_badge && !lxprofile.verification.best_of_badge && !lxprofile.verification.best_of_badge && (
                  <RatingContainer>
                    <StarContainer>
                      <ReviewStar hideScoreText score={score}/>
                      <TextStar>{score}</TextStar>
                    </StarContainer>
                  </RatingContainer>
                )}
                <div>
                  {lxprofile.verification && lxprofile.verification.has_badge && !lxprofile.verification.best_of_badge && (
                    <RatingContainer>
                      <LxIcon
                        src={`${config.assetPath}/static/icons/recommended-badge.png`}
                        srcSet={`${config.assetPath}/static/icons/recommended-badge@2x.png 2x`}
                        alt={lxprofile.name && `${lxprofile.name.first} ${lxprofile.name.last}`}
                        recommend
                      />
                      <div>
                        <Typo.Paragraph>Recommended</Typo.Paragraph>
                        <StarContainer>
                          <ReviewStar hideScoreText score={score}/>
                          <TextStar>{score}</TextStar>
                        </StarContainer>
                      </div>
                    </RatingContainer>
                  )}
                  {lxprofile.verification && lxprofile.verification.best_of_badge && !lxprofile.verification.has_badge && (
                    <RatingContainer>
                      <LxIcon
                        src={`${config.assetPath}/static/icons/bestoflx-badge.png`}
                        srcSet={`${config.assetPath}/static/icons/bestoflx-badge@2x.png 2x`}
                        alt={lxprofile.name && `${lxprofile.name.first} ${lxprofile.name.last}`}
                      />
                      <div>
                        <TitleRating bestOfLx>Best of 2017</TitleRating>
                        <StarContainer>
                          <ReviewStar hideScoreText score={score}/>
                          <TextStar>{score}</TextStar>
                        </StarContainer>
                      </div>
                    </RatingContainer>
                  )}
                </div>
                {lxprofile.verification && lxprofile.verification.best_of_badge && lxprofile.verification.has_badge && (
                  <div>
                    <RatingContainer allRating>
                      <LxIcon
                        src={`${config.assetPath}/static/icons/bestoflx-badge.png`}
                        srcSet={`${config.assetPath}/static/icons/bestoflx-badge@2x.png 2x`}
                        alt={lxprofile.name && `${lxprofile.name.first} ${lxprofile.name.last}`}
                      />
                      <div>
                        <TitleRating>Best of 2017</TitleRating>
                      </div>
                    </RatingContainer>
                    <RatingContainer allRating>
                      <LxIcon
                        src={`${config.assetPath}/static/icons/recommended-badge.png`}
                        srcSet={`${config.assetPath}/static/icons/recommended-badge@2x.png 2x`}
                        alt={lxprofile.name && `${lxprofile.name.first} ${lxprofile.name.last}`}
                        recommend
                      />
                      <div>
                        <TitleRating>Recommended</TitleRating>
                      </div>
                    </RatingContainer>
                    <RatingContainer allRating>
                      <StarContainer allRating>
                        <ReviewStar hideScoreText score={score}/>
                        <TextStar>{score}</TextStar>
                      </StarContainer>
                    </RatingContainer>
                  </div>
                )}
              </ProfileContent>
              <DesktopContainer>
                <HR />
                <FlexTextContainer>
                  <Title>
                    Member Since
                  </Title>
                  <Subtitle>{moment(lxprofile.created_at).format(getMYFormat(locale))}</Subtitle>
                </FlexTextContainer>
                {lxprofile.response && (
                  <div>
                    <FlexTextContainer>
                      <Title>
                      Response Rate
                      </Title>
                      <Subtitle>{getResponse(lxprofile.response).rate}</Subtitle>
                    </FlexTextContainer>
                    <FlexTextContainer>
                      <Title>
                        Response Time
                      </Title>
                      <Subtitle>{getResponse(lxprofile.response).time}</Subtitle>
                    </FlexTextContainer>
                  </div>
                )}
                <HR />
                {this.isVerified() && (
                  <VerificationCheck lxprofile={lxprofile} />
                )}
              </DesktopContainer>
            </FixedContainer>
          </ProfileContainer>
          <ContentContainer>
            <AboutMe>About {lxprofile.is_travel_agency ? 'Us' : 'Me'}</AboutMe>
            <Typo.Paragraph>{lxprofile.profile && lxprofile.profile.about_me}</Typo.Paragraph>
            <HR />
            {lxprofile.name && lxprofile.trips && lxprofile.trips.length > 0
              ? <LocalExpertTrips {...this.props} lxName={lxName} trips={lxprofile.trips} key="trips" />
              : <div key="trips-loader"></div>
            }
            <IsShowHR><HR /></IsShowHR>
            <MoblieContainer>
              <MoblieFirst>
                <FlexTextContainer>
                  <Title>
                    Member Since
                  </Title>
                  <Subtitle>{moment(lxprofile.created_at).format(getMYFormat(locale))}</Subtitle>
                </FlexTextContainer>
                {lxprofile.response && (
                  <div>
                    <FlexTextContainer>
                      <Title>
                        Response Rate
                      </Title>
                      <Subtitle>{getResponse(lxprofile.response).rate}</Subtitle>
                    </FlexTextContainer>
                    <FlexTextContainer>
                      <Title>
                        Response Time
                      </Title>
                      <Subtitle>{getResponse(lxprofile.response).time}</Subtitle>
                    </FlexTextContainer>
                  </div>
                )}
              </MoblieFirst>
              <IsShowHR isMobile><HR /></IsShowHR>
              {this.isVerified() && (
                <BorderVerified>
                  <VerificationCheck lxprofile={lxprofile} />
                </BorderVerified>
              )}
            </MoblieContainer>
            <IsShowHR><HR /></IsShowHR>
            {lxprofile.reviews && lxprofile.reviews.length > 0
              ? (
                <ReviewContainers key="reviews">
                  <Reviews
                    reviews={lxprofile.reviews}
                    lxInfo={lxprofile}
                    trip={lxprofile}
                    rating={lxprofile.rating}
                    categoryScore={lxprofile.review_score}
                    withoutReview={lxprofile.travelers_without_review}
                    user={user}
                    url={url}
                    userCountry={userCountry}
                    onReply={this.onReply}
                    isHideHelpful
                  />
                </ReviewContainers>
              )
              : <div key="reviews-loader"></div>
            }
            {!!galleryName && <Gallery />}
          </ContentContainer>
        </LxContainer>
      </Fragment>
    );
  }
}

export default enhance(LocalExpertProfile);
